import axios from 'axios';
import { MOCK_PAYMENTS, PASS_THROUGH, mockPaymentApi } from './mockPayments';

const Api = {
      async BrandDetails (payload) {
        return axios.get('/marketplace/v3/get_digital_plans_from_vendor', payload );
      },
      async BundleDetails (payload) {
        return axios.get('marketplace/v2/get_bundle_details', payload );
      },
      async CheckBundleError (payload) {
        return axios.get('marketplace/check_bundle_errors', payload );
      },
      async GetOtp (payload) {
        return axios.post('/users/login', payload);
      },
      async VerifyOtp (payload) {
        return axios.post('/users/verify_otp', payload);
      },

      // v2 sends an OTP whether or not the number has an account; v1 login
      // refuses unregistered numbers.
      async GetOtpV2 (payload) {
        return axios.post('/users/v2/login', payload);
      },
      async VerifyOtpV2 (payload) {
        return axios.post('/users/v2/verify_otp', payload);
      },
      // Creates the account after VerifyOtpV2 answered is_new_user.
      async SignUpV2 (payload) {
        return axios.post('/users/v2/register', payload);
      },
      async SignUp (payload) {
        return axios.post('/users/register', payload);
      },
      async MarketPlaceBanner (params={}) {
        return axios.get('/marketplace/v3/get_app_banners',{params})
      },
      async MarketPlaceBundle (params={}) {
        return axios.get('/marketplace/v2/get_section_product_vendor_data?section_id=9',{params})
      },
      async BundleList (params={}) {
        return axios.get('/marketplace/v2/get_bundles_list',{params})
      },
      // This store's categories counted over its whole brand list
      // ([{name, count, logos}]), not over the page of brands loaded so far.
      async StoreCategories (params={}) {
        return axios.get('/marketplace/v2/store_categories', {params})
      },
      async MarketPlaceData (params={}) {
        return axios.get('/marketplace/v2/vendor_v2/', {params})
      },
      // Public. Top brands by sales over the last 90 days, ranked; no counts.
      async Bestsellers () {
        return axios.get('/marketplace/v3/bestsellers/')
      },
      // The cart calls carry the session header explicitly: a plan page can
      // call them straight after the auth sheet signs someone in, before App
      // has re-rendered and copied the token onto axios defaults.
      async EmptyCart () {
        return axios.get('/marketplace/cart/remove_all/', { headers: sessionHeader() })
      },
      async AddToCart (payload) {
        return axios.post('/marketplace/cart/', payload, { headers: sessionHeader() })
      },
      async GetCartItems () {
        return axios.get('/marketplace/cart/', { headers: sessionHeader() })
      },
      // A plan sold on the brand's own site (an affiliate plan): the link that
      // sends this member there, made per click ({ url, brand, plan_id }).
      // Members only; 404 for a plan that is not switched on. Carries the
      // session header like the cart calls, for the same reason.
      async AffiliateLink (planId) {
        return axios.get(`/marketplace/v2/affiliate_link/${encodeURIComponent(planId)}`, {
          params: { surface: 'web' },
          headers: sessionHeader(),
        })
      },
      async PlaceOrder (payload) {
        return axios.post('/marketplace/v3/orders/', payload)
      },
      async BundleCheckout (params) {
        return axios.get('marketplace/v2/get_order_amount_details', {params} );
      },
      async GetFleekCoins () {
        return axios.get('/wallet/get_user_coins')
      },
      async GetOrderDetails (params) {
        return axios.get(`/marketplace/v3/my_orders/${params ? params + '/' : ''}`)
      },
      async GetOrderDetailsFromPaymentId (params) {
        return axios.get('/payments/v3/get_orders_from_payment_id', {params})
      },
      async GetUserDetails () {
        return axios.get('/users/get_profile', { headers: sessionHeader() })
      },
      async FleekCoinsUsed () {
        return axios.get('marketplace/v3/sum_of_fleek_coins_used')
      },
      async AgeRestrictionUpdate (payload) {
        return axios.post('/marketplace/add_age_restrictions_logs', payload)
      },
      async UpdateProile (payload) {
        const form = new FormData();
        if(payload.image_file)
        form.append('image_file', payload.image_file);

        if(payload.name)
        form.append('name', payload.name);

        if(payload.email)
        form.append('email', payload.email);

        if(payload.dob)
        form.append('dob', payload.dob);

        if(payload.gender)
        form.append('gender', payload.gender);

        return axios.post('/users/v2/edit_profile', form);
      },
      async GetAvailableCoupon (payload) {
        return axios.post('/misc/v2/get_available_coupon', payload)
      },
      async ValidateCoupon (payload) {
        return axios.post('/misc/v2/validate_coupon_code', payload)
      },
      async GetOrderAmount (params) {
        return axios.get('/marketplace/v2/get_multiple_order_amount_details', {params})
      },
      async GetSectionsList (params) {
        return axios.get('/marketplace/v2/get_sections_list', { params })
      },
      async GetSectionData (params) {
        return axios.get('/marketplace/v2/get_section_product_vendor_data', { params })
      },
      
      // ========== V4 Payment APIs ==========
      async GetPaymentLinkV4(payload) {
        return axios.post('/payments/v4/create_payment_order', payload);
      },
      
      async ProcessPaymentV4(payload) {
        console.log("Processing payment with V4 API:", payload);
        return axios.post('/payments/v4/process_payment', payload);
      },
      
      async CancelPayment(payload) {
        console.log("Cancelling payment:", payload);
        return axios.post('/payments/v4/cancel_payment', payload);
      },
      
      async GetUserPayments(params = { page: 1, page_size: 20 }) {
        return axios.get('/payments/v4/user_payments', { params });
      },
      async DeleteAccount () {
        return axios.get('/users/delete_account');
      },

      // ========== Gifts ==========
      // Public: anyone holding the link may read who it is from and what it is.
      async GetGift (token) {
        return axios.get(`/gifts/v1/${encodeURIComponent(token)}`);
      },
      // The session header is read at call time: signing in through the auth
      // sheet does not re-render App, so axios defaults can still be empty.
      async ClaimGift (token) {
        return axios.post(`/gifts/v1/${encodeURIComponent(token)}/claim`, {}, { headers: sessionHeader() });
      },
      async GetMyOrdersNow () {
        return axios.get('/marketplace/v3/my_orders/', { headers: sessionHeader() });
      },
      // The buyer's view of the gift on an order they paid for: state, link
      // and the ready-made share text. Says awaiting_payment for a moment
      // after payment, until the gateway's webhook lands.
      async GetGiftForOrder (orderId) {
        return axios.get(`/gifts/v1/order/${encodeURIComponent(orderId)}`, { headers: sessionHeader() });
      },
      // The buyer keeps it instead of sending it. 409 not_keepable once it
      // has been claimed or has already come back.
      async KeepGift (token) {
        return axios.post(`/gifts/v1/${encodeURIComponent(token)}/keep`, {}, { headers: sessionHeader() });
      },
      // Public: whether this client should offer features that are switched
      // server side (gift_enabled). The web reads the row's "web" key.
      // ========== Gmail suggestions (fleek-backend gmaildetect) ==========
      // status.available is false for everyone not offered it (testers only
      // until Google verifies the app), and the card then renders nothing.
      async GmailStatus () {
        return axios.get('/gmail/v1/status', { headers: sessionHeader() });
      },
      async GmailConnect () {
        return axios.post('/gmail/v1/connect', {}, { headers: sessionHeader() });
      },
      async GmailScan () {
        return axios.post('/gmail/v1/scan', {}, { headers: sessionHeader() });
      },
      async GmailDetections () {
        return axios.get('/gmail/v1/detections', { headers: sessionHeader() });
      },
      // `shown`: every row the card showed, ticked or not, so the ones not
      // kept count as a "no" in the inference loop (fleek-backend#5027).
      async GmailKeep (ids, shown) {
        return axios.post('/gmail/v1/keep', shown?.length ? { ids, shown } : { ids }, { headers: sessionHeader() });
      },
      // One inbox by its link id; every inbox when none is given.
      async GmailDisconnect (linkId) {
        return axios.post('/gmail/v1/disconnect', linkId != null ? { link_id: linkId } : {}, { headers: sessionHeader() });
      },

      // ========== AI assistants ==========
      // The user approved an assistant on /connect. Returns a one-time code
      // for the assistant's connector (fleek-backend assistants/CONTRACT.md).
      async ApproveAssistant (payload) {
        return axios.post('/assistants/v1/approve', payload, { headers: sessionHeader() });
      },
      async GoogleLogin (idToken) {
        return axios.post('/users/google_login', { id_token: idToken });
      },
      async AppleLogin (identityToken, name) {
        return axios.post('/users/apple_login', { identity_token: identityToken, ...(name ? { name } : {}) });
      },
      async GetAppUpdate () {
        return axios.get('/config/app_update', { params: { os: 'web' } });
      },
}

const sessionHeader = () => {
  const token = localStorage.getItem('accesstoken');
  return token ? { Authorization: token } : {};
};

/**
 * Dev-only: route the payment calls through the mock rail.
 *
 * MOCK_PAYMENTS is false in any production build (see mockPayments.js for the
 * three conditions), so this loop is a no-op there. A mock method may return
 * PASS_THROUGH to decline a call, in which case the real endpoint answers.
 */
if (MOCK_PAYMENTS) {
  console.warn(
    '%c DEV MOCK PAYMENTS ON ',
    'background:#c2451f;color:#fff;font-weight:700',
    'Payments are simulated. No gateway is contacted and no money moves.'
  );

  Object.keys(mockPaymentApi).forEach((name) => {
    const real = Api[name];
    Api[name] = async (...args) => {
      const result = await mockPaymentApi[name](...args);
      if (result === PASS_THROUGH) return real.apply(Api, args);
      return result;
    };
  });
}


export default Api;
